import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=07663ad0&"
import script from "./EventList.vue?vue&type=script&lang=ts&"
export * from "./EventList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports